import React from "react";
import styled from "styled-components";

const Path = styled.path`
  stroke: ${props => (props.open ? props.theme.white : props.theme.primary)};
  stroke-width: 1px;
  @media (min-width: 1800px) {
    stroke-width: 2px;
  }
`;

const DropdownSmallIcon = ({ open }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.707"
      height="8.061"
      viewBox="0 0 14.707 8.061"
    >
      <Path
        open={open}
        d="M0,0,7,7,0,14"
        transform={
          open
            ? "translate(0.353 7.707) rotate(-90)"
            : "translate(14.354 0.354) rotate(90)"
        }
        fill="none"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default DropdownSmallIcon;
